import { render } from "./FactoryDetail.vue?vue&type=template&id=60295944&lang=pug"
import script from "./FactoryDetail.vue?vue&type=script&lang=js"
export * from "./FactoryDetail.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__